<template>
  <vs-row style="height: 100%; position:relative;">
    <vs-col vs-w="12">
      <div class="vx-card form-card" ref="card">
        <div class="vx-card__header">
          <vs-col vs-type="flex" vs-justify="space-between" vs-align="center" vs-w="12" vs-lg="12" vs-sm="12" vs-xs="12">
            <h3>{{ ['Scegli la causale della cancellazione'].join(' ')}}</h3>
            <feather-icon icon="XIcon" @click="closeSidebar" class="cursor-pointer"></feather-icon>
          </vs-col>
        </div>
        <vs-divider />
        <div class="vx-card__body">
          <form v-on:submit.prevent="" data-vv-scope="selection">
            <vs-row class="m-3">
              <vs-col vs-offset="4" vs-type="flex" vs-justify="center" vs-align="center" vs-w="4">
                <vs-select class="mb-3" v-model="causale_eliminato">
                  <vs-select-item :key="index" :value="item" :text="item" v-for="(item,index) in selector" />
                </vs-select>
              </vs-col>
            </vs-row>
            <vs-row v-if="causale_eliminato == 'Altro'" class="m-3">
              <vs-col vs-offset="4" vs-type="flex" vs-justify="center" vs-align="center" vs-w="4">
                <vs-input v-model="causale_eliminato_text" name="causale_eliminato_text" />
              </vs-col>
            </vs-row>
          </form>
        </div>
        <vs-row slot="footer" class="mb-3 mt-3">
          <vs-divider />
          <vs-col vs-type="flex" vs-justify="space-around" vs-align="center" vs-w="12" vs-lg="12" vs-sm="12" vs-xs="12">
            <vs-button @click="Confirm" type="line" color="warning" icon-pack="feather" icon="icon-save">{{button_text}}</vs-button>
          </vs-col>
        </vs-row>
      </div>
    </vs-col>
  </vs-row>
</template>

<script>
import axios from 'axios'

export default {
  data() {
    return {
      causale_eliminato: "",
      causale_eliminato_text: "",
    }
  },
  props: {
    selected: Object,
    selector: {
      type: Array,
      default: function() {return ['Documento Errato','Altro']},
    },
    stati: Array,
    url: {
      type: String,
      default: process.env.VUE_APP_BACKEND_API+'/rimborso/avanza_stato',
    },
    button_text: {
      type: String,
      default: 'Elimina',
    },
  },
  methods: {
    Confirm() {
      this.causale_eliminato = this.causale_eliminato == 'Altro' ? [this.causale_eliminato,this.causale_eliminato_text.toUpperCase()].join(': ') : this.causale_eliminato
      axios.post(this.url, {id: this.selected.id, id_stato: this.stati.find(e => e.stato == 'Cancellato').id, causale_eliminato: this.causale_eliminato},{
        headers: { "Access-Control-Allow-Origin": "*", 'Content-Type': 'application/json',},
        withCredentials: true,
      }).then(() => {
        this.$emit('close-me')
      })
    },
    closeSidebar(ev) {
      this.$emit('close-me')
      ev.stopPropagation()
    },
  }
}
</script>
